import { useBreadcrumb } from "contexts/breadcrumb/BreadcrumbContext";
import { useQuery } from "hooks/useQuery";
import { useEffect, useState } from "react";
import { OrdersService } from "services/orders";
import { ProgramsService } from "services/programs";
import { TasksService } from "services/tasks";
import { useNavigate } from "react-router-dom";
import {OrderUserTypes} from "../orders/OrderView";

const useCompletedOrderView = ({
                          serialGID,
                          userType
                      }: {
    serialGID?: string;
    userType?: keyof typeof OrderUserTypes;
    activityGuid?: string;
}) => {
    const navigate = useNavigate();
    const { setBreadcrumbs } = useBreadcrumb();
    const [triggerOrderUpdate, setTriggerOrderUpdate] = useState(false);
    const [programOrderTaskState, setProgramOrderTaskState] = useState<{
        actions: string[];
        activityGuid?:string
        canReturn: boolean;
        orderId: number;
    }>();

    //Open Task Api
    const { data: openedTask, loading: isTaskLoading } = useQuery({
        queryFn: async (_: string) => {
            const res = await TasksService.getOrderBySerialGid(serialGID ?? "");
            return {
                data: res,
                hasError: false,
                code: 200,
                description: "",
            };
        },
        options: {
            enabled: !!serialGID ,
        },
        triggers: [serialGID],
    });

    //Order Api
    const { data: order, loading } = useQuery({
        queryFn: async () => {
            const id =  openedTask?.data.orderId ? openedTask.data.orderId : 0;
            console.log(id);
            console.log( openedTask);

            return await OrdersService.getOneById(id);
        },
        options: {
            enabled: !!openedTask?.data.orderId ,
        },
        triggers: [openedTask?.data.orderId, triggerOrderUpdate],
        onError: () => {
            console.log("Error occurred while fetching order");
            navigate(-1);
        },
    });

    //Program Api
    const { data: orderProgram, loading: programLoading } = useQuery({
        queryFn: async () => {
            const id = order?.programId ? order.programId : 0;

            return await ProgramsService.getProgramById(id);
        },
        triggers: [order?.programId],
        options: { enabled: !!order?.programId },
    });

    useEffect(() => {
        if (openedTask?.data.orderId) {
            setProgramOrderTaskState({
                actions: [],
                orderId: openedTask?.data.orderId,
                activityGuid: openedTask?.data.activityGuid,
                canReturn: false,
               
            });
        }
    }, [openedTask]);

    useEffect(() => {
        if ((openedTask && !openedTask?.data.orderId)) {
            navigate(-1);
        }
    }, [openedTask]);

    useEffect(() => {
        setBreadcrumbs([
            {
                localizationKey: "examinerCompletedTasks",
                path: "/home/examinerCompletedTasks" ,
                menuItemId: "examinerCompletedTasks"
            },
            {
                localizationKey:"examinerCompletedOrder",
                path: `/home/examinerCompletedOrder/${serialGID ?? ""}`,
                localizationParameters:{ orderNumber: order?.serialNumber }

            },
        ]);
    }, [order]);

    return {
        loading: loading || programLoading || isTaskLoading,
        programOrderTaskState,
        order: order,
        orderProgram,
        openedTask,
        setTriggerOrderUpdate,
    };
};

export default useCompletedOrderView;
